export const faqItems = [
  {
    question: "高校吃瓜网是一个什么样的网站？",
    answer:
      "高校吃瓜网是一个面向在校学生的校园话题聚合与讨论社区。我们把各高校的热门帖子、讨论区动态整理成清晰的专题，让你快速找到同校吃瓜现场，也方便一次看完学生都在聊什么。",
  },
  {
    question: "网站上的内容是实时更新的吗？",
    answer:
      "讨论区与热搜榜每一到两小时刷新一次，每日精选高赞讨论固定在每晚八点更新一批。对于正在发酵的热点事件，我们会持续补充分条更新，方便你了解完整脉络。",
  },
  {
    question: "怎样才能看到自己学校的吃瓜现场？",
    answer:
      "在讨论区页面顶部的筛选栏里选择你的学校名称即可，也可以直接搜索学校简称或话题关键词。热门学校会默认出现在筛选栏前列，未被收录的学校也可以提交申请。",
  },
  {
    question: "在社区发言需要注意什么？",
    answer:
      "请避免发布涉及具体可识别个人的隐私信息，包括真实姓名、寝室号、联系方式与未经证实的指控。讨论事件本身没问题，但请不要让讨论变成对某个人的围攻。",
  },
  {
    question: "帖子里的内容不一定完全准确怎么办？",
    answer:
      "社区内容以用户分享为主，我们会在热点帖底部标注信息状态。遇到与事实不符的内容，欢迎通过页面底部的纠错入口反馈，我们核实后会补充说明或下架处理。",
  },
  {
    question: "如何申请入驻并贡献自己学校的话题？",
    answer:
      "我们长期招募各校区的内容贡献者，负责整理本校热点、维护讨论区和撰写专题。你可以通过联系我们页面留下基本信息，我们会在一周内回复合作方式。",
  },
];